import * as React from 'react';
import { CLASS_ACTIVITY_ITEM } from '../constants';
import './_ActivityActions.scss';
import { IActivityActionsProps } from './types';
import { Button, ButtonDropdown, Icon, SelectList, SelectListItem } from 'kui';
import { ACTIVITY_TOOLTIP_MORE, ACTIVITY_UNDO } from './constants';

export function ActivityActions({
    activityId,
    isShow,
    onUndo,
}: IActivityActionsProps) {
    const className = CLASS_ACTIVITY_ITEM + '-more';
    const classItem = className + '__action';
    const [isHide, setHide] = React.useState(null);

    if (!isShow || isHide) return null;

    const UndoIcon = require('!!@svgr/webpack!./undo.svg').default;

    return <ButtonDropdown
        className={className}
        directionHorizontal={'right'}
        onClick={e => e.stopPropagation()} // не открывать карту или лист
        portal
    >
        <Button
            className={className + '__button'}
            variant={'icon'}
            tooltip={ACTIVITY_TOOLTIP_MORE}
        >
            <Icon xlink={'more'} size={24}/>
        </Button>
        <SelectList
            fixActive={false}
            onClick={e => e.stopPropagation()} // не открывать карту или лист
        >
            <SelectListItem
                className={`${classItem} ${classItem}--undo`}
                onClick={() => {
                    setHide(true);
                    const activity = document.querySelector(`.${CLASS_ACTIVITY_ITEM}--${activityId}`) as HTMLElement;
                    if (activity) {
                        activity.classList.add(CLASS_ACTIVITY_ITEM + '--old')
                    }
                    onUndo();
                }}
            >
                <UndoIcon />
                {ACTIVITY_UNDO}
            </SelectListItem>
        </SelectList>
    </ButtonDropdown>;
}
